import React from 'react'
import { useSelector } from 'react-redux'
//import { useSelector } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import AsignaturaIdView from '../views/private/AsignaturaIdView'
import AsignaturasThemesView from '../views/private/AsignaturasThemesView'
import AsignaturasView from '../views/private/AsignaturasView'
import ContribucionesView from '../views/private/ContribucionesView'
import CreditosView from '../views/private/CreditosView'
import DocentesView from '../views/private/DocentesView'
import EstadisticasView from '../views/private/EstadisticasView'
import FluiView from '../views/private/FluiView'
import HomeView from '../views/private/HomeView'
import NotActivateAccountView from '../views/private/NotActivateAccountView'
import PerfilView from '../views/private/PerfilView'
import ProgresoAsignaturaView from '../views/private/ProgresoAsignaturaView'
import QuestionAsignaturaView from '../views/private/QuestionAsignaturaView'
const RoutersPrivate = () => {
    const {rol, state} = useSelector(state => state.perfil)
    return (
        <>
            <Switch>

                {
                    state === false
                    ? <Route exact path='/' component={NotActivateAccountView} />
                    : <Route exact path='/' component={HomeView} />
                }
                
                {
                    rol === 'admin'
                    && <Route exact path='/docentes' component={DocentesView} />
                }
                {
                    rol === 'docente'
                    && 
                    <>
                        <Route exact path='/home' component={HomeView} />
                        <Route exact path='/perfil' component={PerfilView} />
                        <Route exact path='/creditos' component={CreditosView} />
                        <Route exact path='/flui' component={FluiView} />
                        <Route exact path='/contribuciones' component={ContribucionesView} />
                        <Route exact path='/estadisticas' component={EstadisticasView} />
                        <Route exact path='/asignaturas' component={AsignaturasView} />
                        <Route exact path='/asignatura/:idAsig' component={AsignaturaIdView} />
                        <Route exact path='/asignatura/:idAsig/:idTema' component={AsignaturasThemesView} />
                        <Route exact path='/asignatura/respuestas/:idAsig/:idTema/:idQuestion/:question' component={QuestionAsignaturaView} />
                        <Route exact path='/progress/asignatura/:idAsig/:asig' component={ProgresoAsignaturaView} />
                    </>
                    
                }
                <Redirect to='/' />
            </Switch>
        </>
    )
}

export default RoutersPrivate